<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :options="[
        { type: 'date', label: '점검일'},
        { type: 'text', label: '점검장소'},
        { type: 'disaster', label: '재해형태'}
      ]" :board="this.board" :is-print="isPrint"/>

    <!--    점검대상-->
<!--    <vs-row class="mt-6">-->
<!--      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">-->
<!--        <h5>-->
<!--          <i class="dot"></i> 점검대상-->
<!--        </h5>-->
<!--      </vs-col>-->
<!--    </vs-row>-->

<!--    <div class="gap-x-6 gap-y-4 mt-4">-->
<!--      <span v-if="isPrint"> {{form.inspectionTitle}} </span>-->
<!--      <div class="ml-group-checkBox flex flex-wrap w-full flex-1" v-else>-->
<!--        <vs-checkbox-->
<!--          class="mr-1 mb-2"-->
<!--          :readonly="board.readonly">-->
<!--          {{form.inspectionTitle}}-->
<!--        </vs-checkbox>-->
<!--      </div>-->
<!--    </div>-->


    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="form.inspectionTitle"
      :list="form.inspectList"
      @update-list-check="updateListCheck"
    />

    <!--    사진대지-->
    <PhotoUploadGridModule      
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>

  </div>
</template>

<script>
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableEquipment from '@/components/TableEquipment'
import DisasterClassSelector from '@/components/selector/DisasterClassSelector'
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'

export default {
  components: {
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }

        this.form.inspectionTitle = this.inspectionTitle
        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      inspectionTitle:'유해화학물질 작업',
      form: {
        inspectionTitle:'유해화학물질 작업',
        stdInfo: { },
        photoList: [],
        fileList: [],
        equipmentList: [],
        inspectList: []
      },
    }
  },
  computed: {
    inspectTable () {
      return [
        {
          id: 1,
          label: '우리 현장에서 발생하거나 취급하는 유해화학물질에 대해 분류･파악하고 있는가?',
          is_checked: ''
        },
        {
          id: 2,
          label: '우리 현장에서 취급하는 유해화학물질의 유해성･위험성 및 관리방안을 종사자에게 교육 하는가?',
          is_checked: ''
        },
        {
          id: 3,
          label: '유해화학물질 취급 담당자를 별도로 지정하고 있는가?',
          is_checked: ''
        },
        {
          id: 4,
          label: '유해화학물질 저장시설의 구조는 해당 물질의 유출･누출을 방지하기 위하여 저장하는 물질의 종류･온도･압력 및 사용 환경에 적합한 것으로 선정하고 있는가?',
          is_checked: ''
        },
        {
          id: 5,
          label: '종사자에게 적절한 방호조치 및 개인보호구를 지급, 착용하도록 관리 하는가?',
          is_checked: ''
        },
        {
          id: 6,
          label: '유해화학물질을 화기나 그 밖에 점화원이 될 우려가 있는 것에 접근, 가열, 마찰시키는 등의 행위를 하는가?',
          is_checked: ''
        },
        {
          id: 7,
          label: '유해화학물질 용기(소분용기포함)에 물질명, 경고표시 등 내용물에 대한 사항을 명확히 표기하는가?',
          is_checked: ''
        },
        {
          id: 8,
          label: '인화성 액체의 증기, 가스에 의한 화재 폭발을 미리 감지하기 위한 가스검지 및 경보장치가 설치되어 있는가?',
          is_checked: ''
        },
        {
          id: 9,
          label: '유해화학물질의 성상에 따라 적절한 저장방법을 선정하고, 유해화학물질 간의 반응 등으로 인한 사고가 발생하지 않도록 조치하고 있는가?',
          is_checked: ''
        },
        {
          id: 10,
          label: '유해화학물질을 취급하는 곳에 응급 시 종사자가 쉽게 사용할 수 있도록 세척시설과 세안설비를 설치하고 있는가?',
          is_checked: ''
        },
        {
          id: 11,
          label: '가스경보기가 작동할 경우 조치사항을 종사자에게 교육하는가?',
          is_checked: ''
        },
        {
          id: 12,
          label: '취급물질에 적절한 소화기를 작업장에 비치하는가?',
          is_checked: ''
        },
        {
          id: 13,
          label: '배관 연결부, 밸브 등의 연결부에서 물질의 누출 여부를 정기적으로 점검 하는가?',
          is_checked: ''
        },
        {
          id: 14,
          label: '인화성 물질을 취급하는 구역은 폭발위험장소로 구분하고, 적정한 방폭 설비를 설치하였는가?',
          is_checked: ''
        },
      ]
    },
  },
  methods : {
    updateList (list) {
      this.form.equipmentList = list
    },
    updateListCheck (indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text
    },
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
